import i18n from 'app/i18/i18'

import {
  DifficultRoute,
  IFindTicketForm,
} from 'entities/ticket/models/find-ticket/models'

import { FlightSearchRecommendation } from 'shared/api/avia/flight-searches'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat, isSearchDateActual } from 'shared/lib/dateFormat'

interface ShortInfoPreviousSearched {
  title: string
  subtitle: string
  key: string
}

export function mapRecommendationToFindTicketForm(
  item: FlightSearchRecommendation,
): IFindTicketForm {
  const firstDirection = item.directions?.[0]
  const secondDirection = item.directions?.[1]

  const direction: DifficultRoute = {
    from: {
      cityName: item.dep.name,
      countryName: item.dep.country,
      cityIataCode: firstDirection.from_,
    },
    to: {
      cityName: item.arr.name,
      countryName: item.arr.country,
      cityIataCode: firstDirection.to,
    },
    date: firstDirection?.date_,
    back_date: secondDirection?.date_ ?? undefined,
  }

  return {
    directions: [direction],
    cabin_class: item.cabin_class,
    adult: item.adults,
    child: item.children,
    infant: item.infants,
    infants_with_place: 0,
  }
}

export const getInfoPrevSearches = (
  items: FlightSearchRecommendation[] | null,
) => {
  if (!items?.length) return []

  return items.reduce<ShortInfoPreviousSearched[]>((result, item, index) => {
    const firstDirection = item.directions?.[0]
    const secondDirection = item.directions?.[1]

    if (!isSearchDateActual(firstDirection?.date_)) {
      return result
    }

    const passengersCount = item.adults + item.children + item.infants
    const passengersText = i18n.t('recent_searches_passengers', {
      count: passengersCount,
    })

    const departureDate = dateFormat(
      firstDirection?.date_,
      DATE_FORMAT_LIST.DATE_MONTH,
    )
    const arrivalDate =
      secondDirection?.date_ && String(secondDirection.date_).length > 0
        ? dateFormat(secondDirection.date_, DATE_FORMAT_LIST.DATE_MONTH)
        : ''
    const datePart = arrivalDate
      ? `${departureDate} - ${arrivalDate}`
      : departureDate

    const title = `${item.dep.name} → ${item.arr.name}`

    const subtitle = firstDirection
      ? `${datePart} • ${passengersText}`
      : passengersText

    result.push({
      title,
      subtitle,
      key: `${item.dep.name}-${index}`,
    })

    return result
  }, [])
}
